import { lifecycleInfo } from '@locales/id/labels';
import type { CylinderStatus } from '@lib/api';
import { Chip } from '@ui';

/** Lifecycle status; "Aktif" is the normal case and only shown when asked. */
export function LifecycleChip({ status, showActive }: { status: CylinderStatus; showActive?: boolean }) {
  if (status === 'ACTIVE' && !showActive) return null;
  const l = lifecycleInfo(status);
  return <Chip tone={l.tone}>{l.label}</Chip>;
}
